var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAuthenticated)?_c('nav',[_c('Navbar')],1):_c('nav',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }